import { render } from "./Health.vue?vue&type=template&id=0d3a2428&scoped=true"
import script from "./Health.vue?vue&type=script&lang=js"
export * from "./Health.vue?vue&type=script&lang=js"

import "./Health.vue?vue&type=style&index=0&id=0d3a2428&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d3a2428"]])

export default __exports__